import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseMasterDataService {

  constructor() { }

  getBaseMasterData(locale: string): Observable<any> {
    console.log('getBaseMasterData called with locale:', locale);
    return of({ data: { mock: 'data' } });
  }
}